export const updateJobWithConnection = /* GraphQL */ `
  mutation UpdateJob(
    $input: UpdateJobInput!
    $condition: ModelJobConditionInput
  ) {
    updateJob(input: $input, condition: $condition) {
      id
      tenant
      landscape
      tenantLandscape
      jobCode
      title
      description
      jobTriggerFilePath
      tasks {
        items {
          version
          product
          batch
          batchName
          versionProductBatch
          jobId
          order
          jobIdOrder
          title
          includeInDownload
          createdAt
          updatedAt
        }
        nextToken
      }
      hasOutputFile
      createdAt
      updatedAt
    }
  }
`;

export const createJobWithConnection = /* GraphQL */ `
  mutation CreateJob(
    $input: CreateJobInput!
    $condition: ModelJobConditionInput
  ) {
    createJob(input: $input, condition: $condition) {
      id
      tenant
      landscape
      tenantLandscape
      jobCode
      title
      description
      jobTriggerFilePath
      tasks {
        items {
          version
          product
          batch
          batchName
          versionProductBatch
          jobId
          order
          jobIdOrder
          title
          includeInDownload
          createdAt
          updatedAt
        }
        nextToken
      }
      hasOutputFile
      createdAt
      updatedAt
    }
  }
`;
